import { Product, ProductListConfig } from "../types/types";
import { layoutMap as cardLayouts } from "../product-card-layouts/layoutMap";
import { raise } from "../utils/raise";
import { VariantProvider } from "@~/contexts/VariantContext/VariantContext";
import { ProductCardEventProvider } from "@~/contexts/ProductCardEventContext/ProductCardEventContext";
import { useRef } from "react";

export type Props = {
  config: ProductListConfig;
  product: Product;
  index: number;
  instanceId: string;
};

export function ProductCard({ product, config, index, instanceId }: Props) {
  const eventsRef = useRef<HTMLElement | null>(null);
  const { name: cardLayoutName, props: cardLayoutProps } =
    config["product-card-layout"];
  const CardLayout =
    cardLayouts[cardLayoutName] ||
    raise(`Couldn't find product-card layout "${cardLayoutName}"`);

  return (
    <VariantProvider product={product} config={config}>
      <ProductCardEventProvider
        product={product}
        config={config}
        index={index}
        eventsRef={eventsRef}
        instanceId={instanceId}
      >
        <CardLayout
          eventsRef={eventsRef}
          config={config}
          product={product}
          configProps={cardLayoutProps}
          index={index}
        />
      </ProductCardEventProvider>
    </VariantProvider>
  );
}
